import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Star } from "lucide-react";
import { DESTINATIONS } from "../mock/mock";
import { Button } from "./ui/button";

const Destinations = ({ limit }) => {
  const items = limit ? DESTINATIONS.slice(0, limit) : DESTINATIONS;

  return (
    <section id="destinations" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-orange-100 text-orange-700 text-xs font-semibold tracking-wider uppercase">
              <span className="w-1.5 h-1.5 rounded-full bg-orange-500" /> Trending Now
            </div>
            <h2 className="mt-4 text-3xl md:text-5xl font-bold text-slate-900 tracking-tight" style={{ fontFamily: "'Poppins', sans-serif" }}>
              Popular Destinations
            </h2>
            <p className="mt-4 text-slate-600 text-lg">
              Handpicked, tested and traveller-loved locations across India. Great starting points for your next escape.
            </p>
          </div>
          <Button asChild variant="outline" className="border-teal-600 text-teal-700 hover:bg-teal-50 self-start">
            <Link to="/destinations">Explore All</Link>
          </Button>
        </div>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {items.map((d, i) => (
            <Link
              key={d.id}
              to="/packages"
              className="group relative rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl transition duration-500"
              style={{
                gridRow: i === 0 ? "span 2" : "",
                height: i === 0 ? "auto" : "340px",
              }}
            >
              <img
                src={d.image}
                alt={d.name}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-110 transition duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-900/40 to-transparent" />

              <div className="absolute top-4 left-4 flex items-center gap-1 px-3 py-1 rounded-full bg-white/95 backdrop-blur text-xs font-semibold text-teal-800">
                <Star className="w-3 h-3 fill-orange-500 text-orange-500" /> {d.tag}
              </div>

              <div className="absolute inset-x-0 bottom-0 p-6 text-white">
                <div className="flex items-center gap-1 text-xs text-white/80">
                  <MapPin className="w-3.5 h-3.5" /> {d.state}
                </div>
                <h3 className="mt-1 text-2xl md:text-3xl font-bold tracking-tight" style={{ fontFamily: "'Poppins', sans-serif" }}>
                  {d.name}
                </h3>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-xs text-white/80">{d.tours} tours available</span>
                  <span className="text-sm font-semibold text-orange-300">from ₹{d.from.toLocaleString("en-IN")}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Destinations;
